import { Users2 } from "lucide-react";
import { useBuddies } from "@/hooks/useBuddies";
import { ActiveBuddy, IncomingBuddy, MatchesSection } from "@/components/community/BuddyParts";

export function BuddiesPanel({ eligibleHint }) {
  const { matches, act, active, incoming, outgoing } = useBuddies(eligibleHint);

  return (
    <div className="warm-card p-6" data-testid="buddies-panel">
      <div className="flex items-center gap-2 mb-1">
        <Users2 className="w-5 h-5 text-amber-700" />
        <h3 className="font-display text-lg font-bold text-stone-900">Habit buddies</h3>
      </div>
      <p className="text-xs text-stone-500 mb-4">Pair up with someone working on the same habit. You'll see a shared streak — days you <em>both</em> showed up — and nothing else about each other. Once you've logged, send a one-tap cheer if they haven't yet.</p>

      {!matches.eligible && (
        <p className="text-sm text-stone-500" data-testid="buddies-not-eligible">Turn on sharing, join a category, and switch on "Share my actual habits" to find buddies with the same habit.</p>
      )}

      {active.length > 0 && (
        <div className="space-y-2 mb-4" data-testid="buddies-active">
          {active.map((b) => <ActiveBuddy key={b.id} b={b} act={act} />)}
        </div>
      )}

      {incoming.length > 0 && (
        <div className="space-y-2 mb-4" data-testid="buddies-incoming">
          <div className="text-[10px] font-bold uppercase tracking-widest text-stone-500">Wants to pair with you</div>
          {incoming.map((b) => <IncomingBuddy key={b.id} b={b} act={act} />)}
        </div>
      )}

      {outgoing.length > 0 && (
        <div className="text-xs text-stone-500 mb-4" data-testid="buddies-outgoing">
          Waiting on: {outgoing.map((b) => `${b.partner.handle} (${b.habit_title})`).join(", ")}
        </div>
      )}

      <MatchesSection matches={matches} act={act} />
    </div>
  );
}
